import { put } from "redux-saga/effects";
import axios from "../../axios";
import * as actionsIndex from "../actions/index";
import { API_Q_CONTENTS } from "../../constants/api";

// Saga generators
export function* initFetchContentsSaga(action) {
  try {
    const response = yield axios.get(API_Q_CONTENTS);
    yield put(actionsIndex.setContents(response.data));
    // const filters = getFiltersHandler(response.data);
    // yield put(actionsIndex.setFiltersContents(filters));
  } catch (error) {
    yield put(actionsIndex.fetchContentsFailed(error));
  }
}
